import React from "react";
import { SmartForm} from './SmartForm'

export function RegisterMail() {
	const fields = [
		{
			label: "Username",
			name: "username",
			type: "text",
			regex: /^[a-zA-Z0-9_]{3,16}$/,
			exclusiveWith: ["wallet"],
		  },
		  {
			label: "Password",
			name: "password",
			type: "text",
		  },
		{
			label: "Mail",
			name: "email",
			type: "text",
			regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
		},
		{
			label: "Wallet",
			name: "wallet",
			type: "select",
			options: [
				{ label: "Dr Grumpy", value: "0xd2Ad7F2aA6641586f88f3418AFACd591d67D24C3" },
				{ label: "Winner #1768", value: "0x77286f4b5f03665ef035fcdd62872b069c265862" }
			],
			regex: /^0x[a-fA-F0-9]{4,}$/,
		},
		
	];
	  const endpoint = {
		"human" : "Register with mail",
		"type" : "POST",
		"url" : "/reg/reg",
	};
	
	return (
		<SmartForm fields={fields} endpoint = {endpoint} />
	);

}

export function LinkWallet() {
	const fields = [
		{
			label: "Username",
			name: "username",
			type: "text",
			regex: /^[a-zA-Z0-9_]{3,16}$/,
		  },
		  {
			label: "Password",
			name: "password",
			type: "text",
		  },
		{
			label: "Wallet",
			name: "new_wallet",
			type: "select",
			options: [
				{ label: "Dr Grumpy", value: "0xd2Ad7F2aA6641586f88f3418AFACd591d67D24C3" },
				{ label: "Winner #1768", value: "0x77286f4b5f03665ef035fcdd62872b069c265862" }
			],
			regex: /^0x[a-fA-F0-9]{4,}$/,
		},
		
	];
	  const endpoint = {
		"human" : "Link Wallet to user Account",
		"type" : "POST",
		"url" : "/reg/linkwallet",
	};
	
	return (
		<SmartForm fields={fields} endpoint = {endpoint} />
	);

}

export function CheckMailVerified() {
	const fields = [
		{
			label: "Mail",
			name: "email",
			type: "text",
			regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
		},
	];
	  const endpoint = {
		"human" : "Check Mail verified",
		"type" : "POST",
		"url" : "/reg/checkMailVerified",
	};
	
	return (
		<SmartForm fields={fields} endpoint = {endpoint} />
	);

}

export function RecoverPW() {
	const fields = [
		{
			label: "Mail",
			name: "email",
			type: "text",
			regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
			exclusiveWith: ["wallet"]
		},
		{
		  label: "Wallet",
		  name: "wallet",
		  type: "select",
		  options: [
			{ label: "Dr Grumpy", value: "0xd2Ad7F2aA6641586f88f3418AFACd591d67D24C3" },
			{ label: "Winner #1768", value: "0x77286f4b5f03665ef035fcdd62872b069c265862" }
		  ],
		  regex: /^0x[a-fA-F0-9]{4,}$/,
		  exclusiveWith: ["username","password","mode"]
		},

	];
	  const endpoint = {
		"human" : "Recover password",
		"type" : "POST",
		"url" : "/reg/recover",
	};
	
	return (
		<SmartForm fields={fields} endpoint = {endpoint} />
	);

}

export function SetPW() {
	const fields = [
		{
			label: "Token",
			name: "token",
			type: "text",
		},
		{
			label: "new Password",
			name: "newPW",
			type: "text",
		},
	];
	  const endpoint = {
		"human" : "Set new password",
		"type" : "POST",
		"url" : "/reg/setpw",
	};
	
	const defaultJson = JSON.stringify({
		info: "execute 'recover PW' first, use the token from the mail to complete the password change including the new desires pw",
	  }, null, 2);
	

	return (
		<SmartForm fields={fields} endpoint = {endpoint} defaultJson={defaultJson}/>
	);
}

